import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { catchError, throwError } from 'rxjs';
import { Emily } from '../app/services/emily';
import { FileUploaderService } from '../app/services/file-uploader';

const AUTH_ATTEMPT_ENDPOINTS = ['/auth/check', '/login'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const location = inject(Location);
  const emily = inject(Emily);
  const file = inject(FileUploaderService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const isAuthAttempt = AUTH_ATTEMPT_ENDPOINTS.some((path) => req.url.includes(path));
      if (err.status === 401 && !isAuthAttempt) {
        emily.close();
        file.close();
        void router.navigate(['/logout'], {
          queryParams: { returnUrl: location.path() },
        });
      }
      return throwError(() => err);
    }),
  );
};
